import actions from '../../actionTypes';

export default area => {
  return {
    type: actions.DELETE_AREA,
    area
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/deleteArea.js